import React from 'react'
import PropTypes from 'prop-types'

//currently MathJax is imported in the index.html file
//you could import it on the js side like this:
//(function () {
//   var script = document.createElement('script');
//   script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js';
//   script.async = true;
//   document.head.appendChild(script);
// })();

const MathJax = (props) => {
  const child = texToMathjax(props.tex) //get child from tex

  if(child && props.display !== true) { //remove display if we want this to be in line
    child.removeAttribute("display")
  }

  return (
    <span ref={(ref) => {
      ref && //if the ref is defined
      ref.childElementCount===0 && //if this span doesn't have any children yet
      child && //if the child is defined
      ref.appendChild(child) //append the child, TODO you could rewrite this to remove all children then append a new child
    }}/>
  )
}

MathJax.propTypes = {
  tex: PropTypes.string.isRequired,
  display: PropTypes.bool,
};

export default MathJax


export function texToMathjax(tex) {
  if(typeof window.MathJax === "object") { //if MathJax is defined as an object
    if(typeof window.MathJax.tex2svg === "function") { //if tex2svg is defined as a function
      return window.MathJax.tex2svg(tex) //return the DOM element
    }
  }
  return null //return nothing
}
